type DebouncedFunction<T extends (...args: any[]) => void> = ((...args: Parameters<T>) => void) & {
    cancel?: () => void;
};
export const Debounce = <T extends (...args: any[]) => void>(func: T, delay: number): DebouncedFunction<T> => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const debounced = ((...args: Parameters<T>) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    }) as DebouncedFunction<T>;

    debounced.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    };

    return debounced;
};
